import { RequestStatus } from "types/requests";
import { LDFlags } from "interfaces/context";

export enum ContextTypeKeys {
  SET_REQUEST_STATUS = "context/SET_REQUEST_STATUS",
  RECEIVE_FEATURE_FLAGS = "context/RECEIVE_FEATURE_FLAGS",
  UPDATE_FEATURE_FLAG = "context/UPDATE_FEATURE_FLAG",
}

export type ContextActionTypes =
  | ISetFlagStatusAction
  | ISetFlagAction
  | IUpdateFlagAction;

export interface ISetFlagStatusAction {
  type: ContextTypeKeys.SET_REQUEST_STATUS;
  payload: RequestStatus;
}

export interface ISetFlagAction {
  type: ContextTypeKeys.RECEIVE_FEATURE_FLAGS;
  payload: LDFlags;
}

export interface IUpdateFlagAction {
  type: ContextTypeKeys.UPDATE_FEATURE_FLAG;
  payload: LDFlags;
}
